import * as React from "react";
import { EntityImage } from "@lib/entities/EntityImage";
import ResponsiveImage from "@components/responsive-image/ResponsiveImage";

const Image = (props: EntityImage) => {
  return <ResponsiveImage {...props.image} layout="responsive" />;
};

export default Image;
